import React from "react";
import BankDetailsPage from "../../components/Pages/Affiliates/Details/BankDetails";

const BankDetails = () => {
  return (
    <div>
      <BankDetailsPage />
    </div>
  );
};

export default BankDetails;
